import axios from 'axios';
import { Rubrique, RubriqueForm, RubriqueType } from 'core/models';

export function getRubriques(type: RubriqueType) {
    return axios.get<Rubrique[]>(`/rubriques/${type}/`);
}

export function getRubrique(id: number) {
    return axios.get<Rubrique>(`/rubriques/${id}/`);
}

export function createRubrique(rubrique: RubriqueForm) {
    return axios.post('/rubriques/', rubrique);
}

export function editRubrique(id: number, rubrique: RubriqueForm) {
    return axios.put(`/rubriques/edit/${id}/`, rubrique);
}

export function deleteRubrique(id: number) {
    return axios.delete(`/rubriques/remove/${id}/`);
}
